import React from 'react';

const YellowFace = ({
  color = '#ff9100',
  size = 142,
  active = false,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 145 145"
      {...props}
    >
      <g transform="translate(-3396.121 21474.879)">
        <circle
          cx="65"
          cy="65"
          r="65"
          transform="translate(3403.621 -21467.379)"
          fill={active ? color : 'none'}
          stroke={color}
          strokeWidth="15"
        />
        <path
          d="M3431.431-21392.137h73.938"
          transform="translate(-0.32 10.132)"
          fill="none"
          stroke={active ? '#fff' : color}
          strokeWidth="9"
        />
      </g>
    </svg>
  );
};

export default YellowFace;
